module.exports = __webpack_public_path__ + "img/icon-c-image.2314b145.svg";